const getters = {
    token: state => state.user.token,
    mainIndex: state => state.user.mainIndex,
    username: state => state.user.username,
    avatarurl: state => state.user.avatarurl,
    drawer: state => state.user.drawer
}

export default getters